import {
  ArrowDownRight,
  ArrowDownToLine,
  ArrowUpRight,
  Zap,
} from 'lucide-react'

import { NetworkLogo, EmptyState } from '~/components/component-library'
import { SplitsDialogContent } from '~/components/component-library/Dialog'
import { TransactionTitle } from '~/components/component-library/TransactionTitle'
import { dialogTitleClassName } from '~/components/smart-accounts/TransactionDetailDialogContent'
import { AssetTransferDisplay } from '~/components/txn-display/AssetTransferDisplay'
import { useSmartAccount } from '~/hooks/useSmartAccounts'
import { useDialogRoutePath } from '~/hooks/utils'
import { OrgAssetTransfer, TransferType } from '~/types'
import { WalletAssetTransfer } from '~/types/cards'
import { cn } from '~/utils/tailwind-utils'
import { isAutoEarnTransfer } from '~/utils/vault'

export const TransferIcon = ({
  transfer,
  size = 'sm',
  networkLogo,
}: {
  transfer: OrgAssetTransfer | WalletAssetTransfer
  size?: 'sm' | 'lg'
  networkLogo?: boolean
}) => {
  const className = cn('rounded-lg p-2', {
    'w-9 h-9': size === 'sm',
    'w-14 h-14': size === 'lg',
  })
  return (
    <div className="relative rounded-lg bg-gray-100 dark:bg-gray-700">
      {isAutoEarnTransfer(transfer) ? (
        <Zap className={className} />
      ) : 'onrampSourceName' in transfer && transfer.onrampSourceName ? (
        <ArrowDownToLine className={className} />
      ) : transfer.transferType === TransferType.Inbound ? (
        <ArrowDownRight className={className} />
      ) : (
        <ArrowUpRight className={className} />
      )}
      {networkLogo && (
        <div className="absolute -bottom-0.5 -right-1">
          <NetworkLogo size={'sm'} chainIds={[transfer.chainId]} />
        </div>
      )}
    </div>
  )
}

export const InboundTransactionDialogContent = ({
  assetTransfer,
  onClose,
  globalModal,
}: {
  assetTransfer: OrgAssetTransfer
  onClose: () => void
  globalModal?: boolean
}) => {
  const { smartAccount } = useSmartAccount(assetTransfer.smartAccountAddress)

  useDialogRoutePath({
    globalModal,
    closeModal: onClose,
    getPath: () => {
      if (assetTransfer && smartAccount) {
        return `/accounts/${smartAccount.address}/transactions/inbound/${assetTransfer.id}/`
      }
    },
  })

  return (
    <SplitsDialogContent
      id="inboundTransactionDetailsDialog"
      title={
        <TransactionTitle
          transaction={assetTransfer}
          className={dialogTitleClassName}
          textWrap
        />
      }
      clampTitle={false}
      variant="info"
    >
      {!assetTransfer || !smartAccount ? (
        <EmptyState title="Transaction not found" />
      ) : (
        <AssetTransferDisplay transfer={assetTransfer} />
      )}
    </SplitsDialogContent>
  )
}
